module.exports = __webpack_public_path__ + "static/img/换绑邮箱.379ff4e.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/换绑邮箱.png
// module id = AHbC
// module chunks = 0